import React from 'react';
import './Badge.css';

const Badge = ({
  children,
  variant = 'default',
  size = 'medium',
  className = '',
  ...props
}) => {
  const badgeClasses = [
    'badge',
    variant,
    size,
    className
  ].filter(Boolean).join(' ');

  return (
    <span className={badgeClasses} {...props}>
      {children}
    </span>
  );
};

// Status Badge Component for PO statuses
export const StatusBadge = ({
  status,
  children,
  className = '',
  ...props
}) => {
  const getStatusVariant = (status) => {
    const statusMap = {
      // PO Statuses
      'draft': 'secondary',
      'DRAFT': 'secondary',
      'awaiting_approval': 'warning',
      'applied': 'warning',
      'APPLIED': 'warning',
      'approved': 'info',
      'APPROVED': 'info',
      'sent': 'primary',
      'SENT_TO_SUPPLIER': 'primary',
      'sent_to_supplier': 'primary',
      'SUPPLIER_RESPONDED': 'info',
      'supplier_responded': 'info',
      'partially_received': 'warning',
      'received': 'success',
      'billed': 'success',
      'cancelled': 'danger',
      'CANCELLED': 'danger',
      'rejected': 'danger',
      'REJECTED': 'danger',

      // User/Generic Statuses
      'active': 'success',
      'inactive': 'danger',
      'verified': 'info',
      'admin': 'primary',

      // Delivery Statuses
      'Delivered': 'success',
      'DELIVERED': 'success',
      'Not_Delivered': 'warning',
      'NOT_DELIVERED': 'warning',
      'Partially_Delivered': 'warning',
      'PARTIALLY_DELIVERED': 'warning'
    };
    return statusMap[status] || 'default';
  };

  const getStatusLabel = (status) => {
    const labelMap = {
      'draft': 'Draft',
      'DRAFT': 'Draft',
      'awaiting_approval': 'Awaiting Approval',
      'applied': 'Applied',
      'APPLIED': 'Applied',
      'approved': 'Approved',
      'APPROVED': 'Approved',
      'sent': 'Sent',
      'SENT_TO_SUPPLIER': 'Sent to Supplier',
      'sent_to_supplier': 'Sent to Supplier',
      'SUPPLIER_RESPONDED': 'Supplier Responded',
      'supplier_responded': 'Supplier Responded',
      'partially_received': 'Partially Received',
      'received': 'Received',
      'billed': 'Billed',
      'cancelled': 'Cancelled',
      'CANCELLED': 'Cancelled',
      'rejected': 'Rejected',
      'REJECTED': 'Rejected',

      // Delivery Statuses
      'Delivered': 'Delivered',
      'DELIVERED': 'Delivered',
      'Not_Delivered': 'Not Delivered',
      'NOT_DELIVERED': 'Not Delivered',
      'Partially_Delivered': 'Partially Delivered',
      'PARTIALLY_DELIVERED': 'Partially Delivered'
    };
    return labelMap[status] || status;
  };

  return (
    <Badge
      variant={getStatusVariant(status)}
      className={`status-badge ${className}`}
      {...props}
    >
      {children || getStatusLabel(status)}
    </Badge>
  );
};

// Stock Level Badge Component
export const StockBadge = ({
  level,
  className = '',
  ...props
}) => {
  const getStockVariant = (level) => {
    if (level === 'low') return 'danger';
    if (level === 'normal') return 'success';
    if (level === 'overstock') return 'warning';
    return 'default';
  };

  const getStockLabel = (level) => {
    const labelMap = {
      'low': 'Low Stock',
      'normal': 'In Stock',
      'overstock': 'Overstock'
    };
    return labelMap[level] || level;
  };

  return (
    <Badge
      variant={getStockVariant(level)}
      className={`stock-badge ${className}`}
      {...props}
    >
      {getStockLabel(level)}
    </Badge>
  );
};

export default Badge;
